import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionProyectoColaboradoresColaboradorComponent {
  data
  desvinculando = false
  idProyecto
  onClose
  onSelect
  vinculando = false

  seleccionar () {
    if (this.data.username === null) {
      this.vinculando = true
    } else {
      this.desvinculando = true
    }
  }

  changeData (campo, valor) {
    this.data[campo] = valor
    this.vinculando = false
    this.desvinculando = false
    this.editando = false
  }
}

module.component('viaticosConfiguracionProyectoColaboradoresColaborador', {
  controller: ViaticosConfiguracionProyectoColaboradoresColaboradorComponent,
  template,
  bindings: {
    idProyecto: '<',
    data: '<',
    onSelect: '&',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/proyecto/colaboradores/colaborador/component.js